import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconOpenInBrowserComponent } from "./med-icon-open-in-browser.component";

@NgModule({
  declarations: [
    MedIconOpenInBrowserComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconOpenInBrowserComponent,
  ],
})
export class MedIconOpenInBrowserModule { }
